import { FC } from 'react'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import * as S from './styles'
import { FeaturedProps } from '../types'

export const Featured: FC<FeaturedProps> = ({ breadcrumb, heading, long_text }) => (
  <S.Featured>
    <Row>
      <Col>
        <Breadcrumb pages={breadcrumb} />
      </Col>
    </Row>
    <Row>
      <Col>
        <S.MainFeatured>
          <Text as='h3' size='xxlg' family='text' weight='semiBlack' margin='0 0 1rem'>
            {heading}
          </Text>
          <Text size='md' color='weak' lineHeight='1.4' margin='0' className='longText'>
            {long_text}
          </Text>
        </S.MainFeatured>
      </Col>
    </Row>
  </S.Featured>
)
